import { createAction } from '@reduxjs/toolkit';

export const getFeatures = createAction('features/getFeatures');
